/**
 * 부스터 타이머 시스템
 * 클릭 부스터, 골든 효과 만료 처리
 */

import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const boosterSystem: TickSystem<GameState, GameAction> = {
  name: 'booster',

  update(state) {
    if (!state.isRunning) return state;

    const now = Date.now();
    let changed = false;
    let newState = { ...state };

    // 클릭 부스터 만료
    if (state.clickBooster.active && now >= state.clickBooster.expiresAt) {
      newState.clickBooster = {
        ...state.clickBooster,
        active: false,
        expiresAt: 0
      };
      changed = true;
    }

    // 골든 효과 만료
    if (state.activeGoldenEffects.length > 0) {
      const activeEffects = state.activeGoldenEffects.filter((effect: any) => now < effect.expiresAt);

      if (activeEffects.length !== state.activeGoldenEffects.length) {
        newState.activeGoldenEffects = activeEffects;
        changed = true;
      }
    }

    return changed ? newState : state;
  }
};
